import { useParams } from 'react-router';
import { Bundle } from '../api/contracts/catalog/bundles';
import { useCustomerSelectedFinanceModels } from '../api/hooks/companies';
import { useFinanceModels } from '../api/hooks/financemodels';
import { useProductsByIds } from '../api/hooks/product';

export const useIsBundlesMissingFinanceModels = (bundles: Bundle[]) => {
  const { partnerId, companyId } = useParams();

  if (!(partnerId && companyId)) throw new Error('Missing params');

  const ids = Array.from(
    new Set(
      [...bundles.map(bundle => [bundle.mainDevice, ...bundle.bundledItems.map(item => item.catalogItem)])].flat()
    )
  );

  const products = useProductsByIds(ids);

  const [selectedModels] = useCustomerSelectedFinanceModels(companyId, partnerId);
  const financeModels = useFinanceModels();

  return products.some(product => {
    const isMainDevice = product.category.isMainDevice;

    if (isMainDevice) {
      const manufacturerId = product.manufacturer.id;
      const categoryId = product.category.id;

      const models = financeModels
        .filter(m => m.categoryId === categoryId && m.manufacturerId === manufacturerId)
        .map(m => m.id);

      const found = selectedModels.financeModelIds.some(value => models.includes(value));

      return !found;
    }

    return !selectedModels.peripheralFinanceModelId;
  });
};
